import type { ThemeConfig } from 'antd';

const globalTheme: ThemeConfig = {
    token: {
        colorPrimary: '#0079c2', // @primary-color
        colorLink: '#374982', // @link-color
        colorSuccess: '#2ecc71', // @success-color
        colorWarning: '#faad14', // @warning-color
        colorError: '#e74c3c', // @error-color

        fontSize: 14, // @font-size-base
        colorTextHeading: 'rgba(0, 0, 0, 0.85)', // @heading-color
        colorText: 'rgba(0, 0, 0, 0.65)', // @text-color
        colorTextSecondary: 'rgba(0, 0, 0, 0.45)', // @text-color-secondary
        colorTextDisabled: 'rgba(0, 0, 0, 0.25)', // @disabled-color

        borderRadius: 4, // @border-radius-base
        colorBorder: '#d6e3f2', // @border-color-base

        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)', // @box-shadow-base

        fontFamily:
            "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'", // @font-family
    },
    components: {
        Layout: {
            headerBg: '#002457', // @layout-header-background
        },
    },
};

const bedBoardIntakeFormTheme: ThemeConfig = {
    token: {
        colorPrimary: '#0f74b8', // marketing blue (focus/accent)
        colorLink: '#1079bf',
        colorSuccess: '#2ecc71',
        colorWarning: '#faad14',
        colorError: '#fd5826',
        colorBgBase: '#f6f6e3', // body background
        colorBgContainer: '#f6f6e3', // layout body background
        fontSize: 16, // body size
        colorTextHeading: '#0c2c63', // heading color
        colorText: '#3d5682', // text color
        colorTextSecondary: '#3d5682', // text color secondary
        colorTextDisabled: '#9aa4b3',
        borderRadius: 8, // input radius
        colorBorder: '#c3c3b0', // border color base
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
        fontFamily: "'vinila-variable', sans-serif",
    },
    components: {
        Layout: {
            headerBg: '#0c2c63',
            bodyBg: '#f6f6e3',
        },
        Form: {
            labelColor: '#3d5682',
            labelRequiredMarkColor: '#fd5826',
        },
        Input: {
            colorBgContainer: 'transparent',
            colorBorder: '#c3c3b0',
            colorText: '#0c2c63',
            colorTextPlaceholder: '#3d5682',
            controlHeight: 52,
            controlHeightLG: 56,
            controlHeightSM: 40,
            paddingInline: 16,
            paddingBlock: 12,
            paddingBlockLG: 14,
            paddingBlockSM: 8,
        },
        Select: {
            colorBgContainer: 'transparent',
            colorBorder: '#c3c3b0',
            colorBgElevated: '#f6f6e3',
            optionActiveBg: '#f6f6e3',
            optionSelectedBg: '#0c2c63',
            optionSelectedColor: '#f6f6e3',
        },
        Calendar: {
            colorBgContainer: '#f6f6e3',
        },
    },
};

export { globalTheme, bedBoardIntakeFormTheme };
